var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 21.0866,
    cy: 20,
    rx: 21.0417,
    ry: 20,
    fill: "#FF4747"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6107 14H15.5638C15.0757 14.0005 14.6077 14.185 14.2625 14.5131C13.9173 14.8412 13.7232 15.286 13.7227 15.75V23.25C13.7232 23.714 13.9173 24.1588 14.2625 24.4869C14.6077 24.815 15.0757 24.9995 15.5638 25H26.6107C27.0988 24.9995 27.5668 24.815 27.912 24.4869C28.2572 24.1588 28.4513 23.714 28.4518 23.25V15.75C28.4513 15.286 28.2572 14.8412 27.912 14.5131C27.5668 14.185 27.0988 14.0005 26.6107 14ZM26.1445 16.8947L21.4101 20.3947C21.3178 20.4629 21.2042 20.4999 21.0872 20.4999C20.9703 20.4999 20.8567 20.4629 20.7644 20.3947L16.03 16.8947C15.9744 16.8548 15.9277 16.8047 15.8926 16.7475C15.8575 16.6902 15.8347 16.6269 15.8255 16.5613C15.8164 16.4956 15.8211 16.4288 15.8393 16.3649C15.8575 16.3009 15.889 16.2411 15.9317 16.1888C15.9745 16.1365 16.0278 16.0928 16.0885 16.0602C16.1492 16.0277 16.2161 16.0069 16.2854 15.9991C16.3546 15.9914 16.4247 15.9968 16.4918 16.015C16.5588 16.0332 16.6213 16.0639 16.6757 16.1053L21.0872 19.3666L25.4988 16.1053C25.6091 16.0261 25.7477 15.9914 25.8848 16.0086C26.0218 16.0259 26.1462 16.0937 26.2311 16.1974C26.3159 16.3011 26.3544 16.4324 26.3382 16.5629C26.322 16.6934 26.2524 16.8126 26.1445 16.8947Z",
    fill: "#FF4747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconRed);
export default __webpack_public_path__ + "static/media/MailIcon_Red.4caba49e6ad786d19addff5786f56243.svg";
export { ForwardRef as ReactComponent };